import styled from '@emotion/styled';
import { layout, space } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

export const Button = styled('button', {
    shouldForwardProp,
})(layout, space);
